import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { IFormConferenceFollowup } from "../Models/Forms/IFormConferenceFollowup";
import { BaseService } from './BaseService';

@Injectable()
export class FormConferenceFollowupService  extends  BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormConferenceFollowup(id: number) {
    return this._http.get(this._baseUrl + "api/FormConferenceFollowup/" + id)
      .map((response: IFormConferenceFollowup) => response as IFormConferenceFollowup)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormConferenceFollowup/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  insertUpdateFormConferenceFollowup(formConferenceFollowupDetails: IFormConferenceFollowup) {
    return this._http.post(this._baseUrl + 'api/FormConferenceFollowup', formConferenceFollowupDetails)
      .map((response: IFormConferenceFollowup) => response as IFormConferenceFollowup)
      .catch(this.errorHandler);
  }

  deleteConferenceFollowup(id) {
    return this._http.delete(this._baseUrl + "api/FormConferenceFollowup" + id)
      .map((response: IFormConferenceFollowup) => response as IFormConferenceFollowup)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}


